<template>
   <div :class="bgClass">
      <div class="row pt-5">
         <div class="col-12 text-center">
            <h2 class="">{{ config.header }}</h2>
            <p class="text-center subheading mb-5">
               {{ descriptionJoiner(config.shortDescription) }}
            </p>
         </div>
      </div>

      <div class="custom-container-1440">
         <div class="row pb-6 justify-content-center">
            <div
               v-for="(item, index) in company"
               :key="index"
               class="col-6 col-sm-4 col-md-2 p-1 pb-md-4 d-flex align-items-center justify-content-center"
            >
               <div class="company-logo-container">
                  <div :class="['logo', 'mono-logo-container', item, `${item}-dims`]" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      config: {
         type: Object,
         required: true,
      },
      bgClass: {
         type: String,
         default: '',
      },
   },
   data() {
      return {
         company: [
            'logo-mono-adobe',
            'logo-mono-atlassian',
            'logo-mono-autodesk',
            'logo-mono-avangate',
            'logo-mono-capgemini',
            'logo-mono-caterpillar',
            'logo-mono-cisco',
            'logo-mono-dellemc',
            'logo-mono-deloitte',
            'logo-mono-facebook',
            'logo-mono-genpact',
            'logo-mono-google',
            'logo-mono-hp',
            'logo-mono-huawei',
            'logo-mono-ibm',
            'logo-mono-infosys',
            'logo-mono-intel',
            'logo-mono-jda',
            'logo-mono-linkedin',
            'logo-mono-mcafee',
            'logo-mono-microsoft',
            'logo-mono-netapp',
            'logo-mono-nielsen',
            'logo-mono-oracle',
            'logo-mono-philips',
            'logo-mono-sunmicro',
            'logo-mono-vanguard',
            'logo-mono-vmware',
            'logo-mono-walmart',
         ],
      };
   },
};
</script>

<style lang="scss" scoped>
.logo {
   margin: 0 auto;
}

.company-logo-container {
   width: 140px;
   height: 40px;
   transform: scale(1.2);
   text-align: center;
}

.logo-mono-avangate {
   background-position-y: -341px;
}

.logo-mono-oracle {
   transform: scale(1.5) !important;
}
.logo-mono-vanguard {
   background-position-y: -2578px;
}

.logo-mono-vmware {
   transform: scale(1.5) !important;
}

.logo {
   transform: scale(0.9);
   @media (min-width: 768px) {
      transform: scale(1);
   }

   @media (min-width: 992px) {
      transform: scale(1.2);
   }

   @media (min-width: 1024px) {
      transform: scale(1.3);
   }
}

.bottom-section {
   background: linear-gradient(180deg, #f8fafc 0%, #f8fafc 100%);

   h3 {
      color: #2f3160;
      font-size: 30px;
      line-height: 38px;
   }
}
</style>
